const isAuthorizedRoles = (keycloak, roles) => {

    if (keycloak.authenticated && roles) {

        if (keycloak.tokenParsed.realm_access.roles.includes('ROLE_UNIP')) {
            return true
        } else {
            return roles.some(role => {
                const realm = keycloak.hasRealmRole(role) || keycloak.hasRealmRole(role.toLowerCase());
                const resource = keycloak.hasResourceRole(role) || keycloak.hasResourceRole(role.toLowerCase());
                return realm || resource;
            })
        }

    }
    return false;
}

export {
    isAuthorizedRoles
}

